import axios from '@/plugins/axios'

export function getProfitOrders(params = {}) {
    return axios.get('profit', {
        params,
    })
}

export function getProfitStatistics(params = {}) {
    return axios.get('profit/statistics', {
        params,
    })
}

export function getProfitTotal(params = {}) {
    return axios.get('profit/profitTotal', {
        params,
    })
}

const convertRes2Blob = (response, fileName) => {
    const blob = new Blob([response.data], {
        type: 'application/vnd.ms-excel',
        // type: 'application/pdf',
    })
    let nav = window.navigator
    if (typeof nav.msSaveBlob !== 'undefined') {
        nav.msSaveBlob(blob, decodeURI(fileName))
    } else {
        const blobURL = window.URL.createObjectURL(blob)
        const tempLink = document.createElement('a')
        tempLink.style.display = 'none'
        tempLink.href = blobURL
        tempLink.setAttribute('download', decodeURI(fileName))
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank')
        }
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink) //下载后文件名、
        window.URL
        console.log(tempLink, 'tem')
    }
}

/**
 * 从 content-disposition 中提取文件名（兼容 UTF-8 中文编码）
 * @param {string} disposition - 响应头的 content-disposition 值
 * @returns {string} 提取后的文件名（默认：利润报表.xlsx）
 */
const extractFileName = (disposition,defaultName = '收益.xlsx') => {
    if (!disposition) return defaultName;

    // 优先匹配 UTF-8 编码的 filename* 字段（你的场景核心）
    // 正则匹配：filename*=utf-8''后接任意字符（非分号结束，避免匹配后续内容）
    const utf8Reg = /filename\*=utf-8''([^;]+)/i;
    const utf8Match = disposition.match(utf8Reg);

    if (utf8Match && utf8Match[1]) {
        // 解码 UTF-8 编码的中文（%E6%8A%80 这类字符转中文）
        return decodeURIComponent(utf8Match[1].trim());
    }

    // 兼容普通 filename 字段（如果后续有非空值场景）
    const normalReg = /filename=([^;]+)/i;
    const normalMatch = disposition.match(normalReg);
    if (normalMatch && normalMatch[1]) {
        // 去除引号、空格，忽略空值
        const fileName = normalMatch[1].replace(/["';\s]/g, '');
        return fileName || defaultName;
    }

    // 兜底默认文件名
    return defaultName;
}
